class UxProductDescription extends HTMLElement {
  connectedCallback() {
    if (this.dataset.enhanced) return;
    const description = this.querySelector('.ux-product-description');
    if (!description) return;
    this.dataset.enhanced = 'true';
    const images = [...description.querySelectorAll('img')].filter(image => !/size|chart|measure|מידות/i.test(`${image.alt} ${image.title} ${image.getAttribute('src')}`));
    if (!images.length) return;
    const details = document.createElement('details');
    details.className = 'ux-extra-photos';
    const summary = document.createElement('summary');
    summary.textContent = this.dataset.extraTitle;
    const gallery = document.createElement('div');
    gallery.className = 'ux-extra-photos__grid';
    details.append(summary, gallery);
    for (const image of images) {
      const parent = image.parentElement;
      image.loading = 'lazy';
      gallery.append(image);
      if (parent !== description && !parent.textContent.trim() && !parent.children.length) parent.remove();
    }
    this.append(details);
  }
}
if (!customElements.get('ux-product-description')) customElements.define('ux-product-description', UxProductDescription);
